const __request = require(`@/lib/data-service/default/__request/`)

/**
 * 查看出团通知书
 */
export default function getDetail(val) {
    var pParameter = {}
    pParameter.method = "POST"
    pParameter.urlSuffix = "/web/common/lookDepartInform"
    pParameter.data = val
    return new Promise(function (resolve, reject) {
        resolve(__request(pParameter))
    })
} 